import {
  ChangeDetectorRef,
  Component,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  ViewEncapsulation
} from '@angular/core';
import { isPlatformBrowser } from "@angular/common";
import { environment } from "environments/environment";
import { AdLocationSettings } from "../ad-model";
import { ImageResizePresets } from "../../img-resize/image-resize.service";
import {
  ErrorHandlerStrategy,
  HydraCollection,
  WebServiceOptions,
  WebServiceSubResourceFetchMode
} from "@adeo/ngx-kozikaza-api";
import { DealArea, DealAreaService } from '@adeo/ngx-kozikaza-api/affiliate';
import { map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { HttpParams } from '@angular/common/http';
import { of } from 'rxjs/internal/observable/of';
import { Observable, Subject, Subscription, forkJoin, timer } from 'rxjs';
import { CookieService } from 'ngx-cookie';
import { AffiliateService } from 'src/app/shared/services/utilities/affiliate.service';


@Component({
  selector: 'app-da-location',
  templateUrl: './da-location.component.html',
  encapsulation: ViewEncapsulation.None,
})
export class DaLocationComponent implements OnInit, OnDestroy {
  @Input() adLocation: string[];
  @Input() adLocationSettings: AdLocationSettings;
  @Input() adYOffset: number | null = null;
  dealsArea: DealArea[] = [];
  alreadyUsed = [];
  sub: Subscription;
  indexDelay = 0;

  public isBrowser = false;
  public isProd = false;
  public imgPreset: ImageResizePresets;
  private unsubscribe$: Subject<boolean> = new Subject<false>();

  constructor(

    @Inject(PLATFORM_ID) private platformId: object,
    private dealAreaService: DealAreaService,
    private cdr: ChangeDetectorRef,
    private readonly cookieService: CookieService,
    private affilteService:AffiliateService
  ) {

    this.isProd = environment.env === 'prod';
    this.isBrowser = isPlatformBrowser(this.platformId);

  }

  ngOnInit(): void {
    if (this.isBrowser) {
      this.imgPreset = `w${this.adLocationSettings.width}` as ImageResizePresets;
      if (this.adLocationSettings.delay != undefined) {
        this.startAds();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.sub && !this.sub.closed) {
      this.sub.unsubscribe();
    }
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  startAds(): void {
    let delay = (typeof this.adLocationSettings.delay === 'number') ? this.adLocationSettings.delay : this.adLocationSettings.delay[this.indexDelay];
    if (this.cookieService.get('kzkz_divide_delay_by')) {
      delay = delay / parseInt(this.cookieService.get('kzkz_divide_delay_by'));
    }
    const req: Observable<boolean | number> = ((this.adLocationSettings.delay === 0) ? of(true) : timer(delay))

    this.sub = req.pipe(
        switchMap(() => {
          const webServiceOptions: WebServiceOptions = {
            subResourceFetchMode: WebServiceSubResourceFetchMode.SYNC,
            errorHandlerStrategy: ErrorHandlerStrategy.Ignore,
            refresh: true,
            query: new HttpParams({
              fromObject: {
                'areas[]': [
                  ...this.adLocation
                ],
                'alreadyUsed[]': [
                  ...this.alreadyUsed
                ]
              }
            })
          };

          return this.dealAreaService.getDealAreasSegmentation([{deal: ['brand']}], webServiceOptions)
        }),
        tap((dealsArea: HydraCollection<any>) => {
          this.dealsArea = dealsArea['hydra:member'];        
          (typeof this.adLocationSettings.delay !== 'number' && this.indexDelay === (this.adLocationSettings.delay.length - 1)) ? this.indexDelay = 0 : this.indexDelay++;
          if (this.dealsArea && this.dealsArea.length) {
            this.alreadyUsed.push(this.dealsArea[0]['@id']);
          } else {
            this.alreadyUsed = [];
          }
          this.cdr.detectChanges();

          if ((this.adLocationSettings.delay !== 0)) {
            this.startAds();
          }
        }),
        switchMap(() => {
          // If there are no dealsArea, avoid executing the following logic
          if (!this.dealsArea.length) {
            return of(null);
          }
      
          // Create an observable for each item to fetch tracking link info
          const trackingLinksObservables = this.dealsArea.map((item:any) => 
            this.getTrackingLinkInfo(item?.trackingLinks[0]).pipe(
              tap(data => {
                item.tinyUrl = data.tinyUrl;
                item.pixelUrl = data.pixelUrl;
              }),
              takeUntil(this.unsubscribe$),
            )
          );
      
          // Wait for all tracking link info fetches to complete
          return forkJoin(trackingLinksObservables);
        }),
        tap(() => {
          // Trigger change detection once all async operations are completed
          this.cdr.detectChanges();
        }),
      ).subscribe();
  }
  getTrackingLinkInfo(link:string) {
    return this.affilteService.getTrackingLinksInfo(link)
  }
}
